import { Injectable, inject } from "@angular/core";
import { NxDatepickerIntl } from "@allianz/ng-aquila/datefield";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class NxDatepickerIntlProvider extends NxDatepickerIntl {
  private translateService = inject(TranslateService);

  constructor() {
    super();

    this.switchToMultiYearViewLabel = this.translateService.instant(
      "nx-datepicker-intl.switchToMultiYearViewLabel",
    );
    this.switchToMonthViewLabel = this.translateService.instant(
      "nx-datepicker-intl.switchToMonthViewLabel",
    );
  }

  override switchToMonthViewLabel: string;
  override switchToMultiYearViewLabel: string;
}
